import { useSelector } from 'react-redux';

const NawyNowFormEmailIcon = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return isMobile ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M11.9395 13.6693H5.27279C3.27279 13.6693 1.93945 12.6693 1.93945 10.3359V5.66927C1.93945 3.33594 3.27279 2.33594 5.27279 2.33594H11.9395C13.9395 2.33594 15.2728 3.33594 15.2728 5.66927V10.3359C15.2728 12.6693 13.9395 13.6693 11.9395 13.6693Z"
        stroke="#1A2028"
        stroke-width="1.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9382 6L9.85148 7.66667C9.16481 8.21333 8.03815 8.21333 7.35148 7.66667L5.27148 6"
        stroke="#1A2028"
        stroke-width="1.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M11.333 14.4818H4.66634C2.66634 14.4818 1.33301 13.4818 1.33301 11.1484V6.48177C1.33301 4.14844 2.66634 3.14844 4.66634 3.14844H11.333C13.333 3.14844 14.6663 4.14844 14.6663 6.48177V11.1484C14.6663 13.4818 13.333 14.4818 11.333 14.4818Z"
        stroke="white"
        stroke-width="1.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3337 6.8125L9.24699 8.47917C8.56032 9.02583 7.43366 9.02583 6.74699 8.47917L4.66699 6.8125"
        stroke="white"
        stroke-width="1.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default NawyNowFormEmailIcon;
